import { routePaths } from "@/App";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import type { Tour } from "@/libs/tours/types";
import { Calendar } from "lucide-react";
import { Link } from "react-router";

interface TourCardProps {
  tour: Tour;
}

export function TourCard({ tour }: TourCardProps) {
  return (
    <Link
      to={
        tour.state === "completed"
          ? routePaths.createTourSummaryPath(tour.id)
          : routePaths.createTourPath(tour.id)
      }
    >
      <Card className="hover:opacity-80 w-full overflow-hidden shadow-none">
        <CardHeader className="p-4">
          <CardTitle className="text-lg font-semibold text-slate-800 truncate">
            {tour.name}
          </CardTitle>

          <CardDescription className="flex items-center text-[#6A80A8] gap-2 font-medium">
            <Calendar className="w-4 h-4 text-[#6A80A8]" />
            {new Date(tour.date).toLocaleString("de-DE", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </CardDescription>
        </CardHeader>
      </Card>
    </Link>
  );
}
